import { createAsyncThunk } from '@reduxjs/toolkit';

import { AuthService } from '@/Module/Auth/Service';
import { CookieService } from '@/Module/Core/Service';
import type { IExamAuth } from '@/Module/Exam/Model/ApiModel';

export const authGetExamTokenAction = createAsyncThunk<IExamAuth>('auth/getExamToken', async () => {
  const accessToken = CookieService.getAccessToken();
  return AuthService.getExamToken(accessToken, { disabledAutoError: true }).then(({ data: { data } }) => data);
});
